import {
  Avatar,
  Box,
  Center,
  Heading,
  Progress,
  Stack,
  useColorModeValue,
  Text,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import { doc, getDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../components/common/Breadcrumb";
import MarkDownEditor from "../../components/MarkDownEditor/MarkDownEditor";
import { db } from "../../firebaseConfig";
import Logo from "../../assets/gadget.svg";
import { BiUser, BiCalendar, BiPurchaseTag } from "react-icons/bi";

const BlogPage = () => {
  const [data, setData] = useState<any>("");
  const { id } = useParams();

  async function getDocument(coll: any, id: any) {
    try {
      const docRef = doc(db, coll, id);
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        setData(data);
        return snap.data();
      } else {
        throw new Error(`No such document: ${coll}.${id}`);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    const GetData = async () => {
      try {
        const data: any = await getDocument("Blog", id);
        setData(data);
      } catch (error) {
        console.error(error);
      }
    };
    GetData();
  }, []);

  const bredData = [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Blog",
      link: "/blog",
      active: true,
    },
  ];

  return (
    <>
      <Section>
        <Breadcrumb bredData={bredData} />

        {!data && <Progress size="xs" isIndeterminate />}
        <div className="main-data-container">
          <h1>{data.title}</h1>
          <div className="minimal-desc">
            <div className="gad-team">
              <img src={Logo} alt="" />
              <div className="icon-cont">
                <BiUser className="icon" />
                Gadgeting Team
              </div>
            </div>
            <div>
              <div className="icon-cont">
                <BiCalendar className="icon" />
                {data.createdAt?.toDate().toDateString()}
              </div>
            </div>
            <div>
              <div className="icon-cont">
                <BiPurchaseTag className="icon" />
                {data.tags}
              </div>
            </div>
          </div>
          <div className="short-dec">
          <p>{data.shortDec}</p>
          </div>

        </div>
        <div className="card">
          {data && [data].length && (
            <>
              <MarkDownEditor data={data.content} />
            </>
          )}
        </div>
      </Section>
    </>
  );
};

export default BlogPage;

const Section = styled.section`
  padding: 15%;
  padding-top: 1rem;
  .card {
    /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
    padding: 5px;
    margin-top: 2rem;
    border-radius: 8px;
  }
  .image-container {
    height: 410px;
    position: relative;
    width: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image-container img {
    height: 100%;
  }
  .main-data-container {
    margin-top: 2rem;
    h1 {
      font-size: 41px;
      line-height: 51px;
      font-weight: bold;
    }
  }
  .minimal-desc {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    .icon-cont {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #95989d;
      cursor: pointer;
      margin-right: 30px;
    }
    .icon-cont:hover {
      color: #ff5733;
    }
    .icon {
      color: #ff5733;
      margin-right: 4px;
    }
  }
  .gad-team {
    display: flex;
    img {
      width: 34px;
      height: 34px;
      border-radius: 0%;
    }
  }
  .short-dec{
    margin-top: 30px;
    margin-bottom: 30px;
    width: 90%;
  }
  @media only screen and (max-width: 600px) {
    padding: 5%;
    .gad-team {
    display: flex;
    img {
      width: 24px;
      height: 24px;
      border-radius: 0%;
    }
  }
  .icon-cont {
     font-size: 10px;
     flex-wrap: wrap;
    }
  }
`;
